import { initialize } from '@open-iframe-resizer/core';

initialize( {}, '.iframe-resizer' );
